import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IGlobalState } from './types';
import initialGlobalState from './initialState';
import { LanguageList, ThemeList } from '../globalTypes';

const globalSlice = createSlice({
  name: 'global',
  initialState: initialGlobalState(),
  reducers: {
    set_loading(state: IGlobalState) {
      state.loading = true;
    },
    set_error(state: IGlobalState, action: PayloadAction<any>) {
      state.error = action.payload;
      state.loading = false;
    },
    set_theme(state: IGlobalState, action: PayloadAction<ThemeList>) {
      state.scheme = action.payload;
      state.loading = false;
    },
    set_lang(state: IGlobalState, action: PayloadAction<LanguageList>) {
      state.lang = action.payload;
      localStorage.setItem('lang', action.payload);
      state.loading = false;
    },
    set_search_params(state: IGlobalState, action: PayloadAction<string>) {
      state.searchParams = action.payload;
      state.loading = false;
    },
    setActiveFilters(state, action) {
      state.activeFilters = { ...state.activeFilters, ...action.payload };
    },
    clearActiveFilters(state) {
      state.activeFilters = {};
    },
    set_superAdmin(state: IGlobalState, action: PayloadAction<boolean>) {
      state.superAdmin = action.payload;
    },
    set_hierarchical_levels_scope(
      state,
      action: PayloadAction<IGlobalState['hierarchicalLevelsScope']>
    ) {
      state.hierarchicalLevelsScope = action.payload;
    },
    set_main_organization(
      state: IGlobalState,
      action: PayloadAction<number | null>
    ) {
      state.mainOrganization = action.payload;
    },
    set_bru_assigned(
      state: IGlobalState,
      action: PayloadAction<string | null>
    ) {
      state.bruAssigned = action.payload;
    },
    set_schema_tables(state: IGlobalState, action: PayloadAction<string[]>) {
      state.schemaTables = action.payload;
      state.loading = false;
    }
  }
});

export default globalSlice;
